module.exports = __webpack_public_path__ + "static/media/test15_1.f5d45beb.png";